export default __webpack_public_path__ + "images/user_insights.1177a49860b69ccdfc8656597d9937b8.png";